$radioWidth: 18px;
$radioHeight: 18px;

:host {
  --font-family: var(--font-family-secondary);
  --font-size: var(--body-size-large);
  margin-bottom: 8px;
  width: auto;
  height: auto;
}

:host([wrapped]) {
  .radio-button {
    align-items: flex-start;
    &--text {
      white-space: normal;
      text-overflow: unset;
    }
  }
}

.radio-button {
  display: flex;
  position: relative;
  font-size: var(--font-size);
  font-family: var(--font-family);
  line-height: 1.5;
  justify-content: flex-start;
  align-items: center;

  &--input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0px;
    overflow: hidden;
    white-space: nowrap;
    border: 0px;
    z-index: 1000;
    cursor: pointer;
  }

  &--appearance {
    width: 18px;
    height: 18px;
    border: 2px solid var(--chart-300-icon-buttons);
    border-radius: 50%;
    margin-right: var(--spacer);
    position: relative;
    flex: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;

    &:before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: var(--blue-layout-400-primary);
      border-radius: 50%;
      transform: scale(0);
      transition: all 0.3s ease-in-out;
    }
  }

  &--text {
    color: var(--main-titles-inputs-600);
    max-width: var(--max-width-gz-radio-label, auto);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    .radio-button--appearance {
      border-color: var(--main-titles-inputs-602);
    }
  }
  &[highlightOnCheck] {
    .radio-button--appearance {
      display: none;
    }
  }

  &:active {
    .radio-button--appearance {
      border-color: var(--blue-layout-300-active);
    }
  }

  &.checked {
    &[highlightOnCheck] {
      .radio-button--text {
        font-weight: bold;
      }
    }
    .radio-button--appearance {
      border-color: var(--blue-layout-400-primary);
      &:before {
        transform: scale(1);
      }
    }

    &:hover {
      .radio-button--appearance {
        border-color: var(--blue-layout-303-active);
        &:before {
          background-color: var(--blue-layout-303-active);
        }
      }
    }

    .radio-button--input:active + .radio-button--appearance {
      border-color: var(--blue-layout-500-focus);

      &::before {
        background-color: var(--blue-layout-500-focus);
      }
    }
  }

  &--input:focus-visible + .radio-button--appearance {
    border-color: var(--blue-layout-500-focus);

    &::before {
      background-color: var(--blue-layout-500-focus);
    }
  }

  &--input:active + .radio-button--appearance {
    border-color: var(--blue-layout-300-active);

    &::before {
      background-color: var(--blue-layout-300-active);
    }
  }

  &.disabled {
    pointer-events: none;
    .radio-button--input {
      cursor: default;
    }
    .radio-button--appearance {
      border-color: var(--grey-layout-202-disabled-icons);
      &:before {
        background-color: var(--grey-layout-202-disabled-icons);
      }
    }

    .radio-button--text {
      color: var(--grey-layout-200-disabled);
    }
  }

  &.disabled.checked {
    .radio-button--appearance {
      border-color: var(--grey-layout-200-disabled);

      &:before {
        background-color: var(--grey-layout-200-disabled);
      }
    }

    .radio-button--text {
      color: var(--main-titles-inputs-600);
    }
  }
}
